import { useTranslations } from '@fshr/context/i18n-context';
import type { FeaturedContentItem } from '@micro-apps/env';
import { appendIcmpQueryParam, slugifyAnalyticsSegment } from '@fshr/shared';
import { SearchModalCard } from './SearchModalCard';

const FeaturedSearchItemComponent = ({
	item,
	showSeparator,
	isPreferredPartner,
}: {
	item: FeaturedContentItem;
	showSeparator: boolean;
	isPreferredPartner: boolean;
}) => {
	const cardTitleSlug = slugifyAnalyticsSegment((item.title || '').toLowerCase());
	const url =
		isPreferredPartner && cardTitleSlug
			? appendIcmpQueryParam(item.url, `pp-search_inspiration-${cardTitleSlug}`)
			: item.url;
	return (
		<SearchModalCard
			image={item.image}
			title={item.title}
			description={item.description}
			url={url}
			variant="featured"
			showSeparator={showSeparator}
		/>
	);
};

const FeaturedContent = ({
	items,
	error,
	isPreferredPartner = false,
}: {
	items: FeaturedContentItem[];
	error?: unknown;
	isPreferredPartner?: boolean;
}) => {
	const t = useTranslations();

	if (error || !items?.length) {
		return null;
	}

	return (
		<div className="flex flex-col spacing-stack-xs pb-[30px]">
			<h2 className="text-label text-text-secondary spacing-heading-xs">{t('Featured Content')}</h2>
			<div className="flex flex-col spacing-stack-s">
				{items.map((item, index) => (
					<FeaturedSearchItemComponent
						key={`featured-${index}-${item.url}`}
						item={item}
						showSeparator={index !== items.length - 1}
						isPreferredPartner={isPreferredPartner}
					/>
				))}
			</div>
		</div>
	);
};

export default FeaturedContent;
